require('./lbaSpacer.scss');

const $inject = [];
const lbaSpacer = function () {
  return {
    restrict: 'A',
    template: require('./lbaSpacer.html')
  }
};

lbaSpacer.$inject = $inject;
export default lbaSpacer;



// WEBPACK FOOTER //
// ./src/components/lbaSpacer/lbaSpacerDir.js